module.exports = __webpack_public_path__ + "static/img/right-home-row-5.8c490f2c.webp";